import React from "react";
import styled from "styled-components";
import BaseDialog from "components/BaseDialog";
import { Button, ButtonLabel, Title } from "./tutorial-styles";

const PromotionContent = styled.div`
  padding: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  overflow: hidden;
`;

const PickerContent = styled.div`
  padding: 15px;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  overflow: hidden;
  background-color: white;
`;

export const LocationPickerModal = ({open, onClose, locationPickerConfig, lang, handleLocationChange}) => {
  return (
    <BaseDialog 
      open={open} 
      onClose={onClose} 
      style={{borderRadius: '24px'}} 
      contentStyle={{width: '300px'}}
    >
      <PickerContent>
        <div style={{ maxWidth: "80vw", minWidth: "16em", display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch', gap: '10px' }}>
          <Title>{!!lang ? locationPickerConfig.title.en : locationPickerConfig.title.es}</Title>
          {locationPickerConfig.locations.map(({title, url}) => 
            <Button type="button" onClick={()=>handleLocationChange(url)}>
              <ButtonLabel dangerouslySetInnerHTML={{ __html: !!lang ? title.en : title.es }} />
            </Button>
          )}
        </div>
      </PickerContent>
    </BaseDialog>
  )
};

export const PromoModal = ({open, onClose, closePromo, promotionConfig}) => {
  const onLocalClose = () => {
    closePromo()
    onClose();
  }
  return (
    <BaseDialog open={open} onClose={onLocalClose} style={{borderRadius: '24px'}}>
      <PromotionContent backgroundColor={promotionConfig?.backgroundColor}>
        <div style={{ maxWidth: "80vw", minWidth: "16em", height: "70vh", display: "flex" }}>
          <Promotion data={promotionConfig} handleClose={onLocalClose} />
        </div>
      </PromotionContent>
    </BaseDialog>
  )
}

export const MenuPickerModal = ({open, onClose, lang, menuPickerConfig, buttonLabel}) => {

  const  handleExternalMenu = () => {
    if(!!menuPickerConfig.externalMenuURL) {
      window.location.href = menuPickerConfig.externalMenuURL;
      return;
    }
    onClose();
  }

  return (
    <BaseDialog open={open} onClose={onClose} style={{borderRadius: '24px'}} >
      <PickerContent>
        <div style={{ maxWidth: "80vw", minWidth: "16em", display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch', gap: '10px' }}>
          <Title>{!!lang ? menuPickerConfig.title.en : menuPickerConfig.title.es}</Title>
          <Button type="button" onClick={onClose}>
            <ButtonLabel>
              {buttonLabel}
            </ButtonLabel>
          </Button>
          <Button type="button" onClick={handleExternalMenu}>
            <ButtonLabel dangerouslySetInnerHTML={{ __html: !!lang ? menuPickerConfig.externalMenuName.en : menuPickerConfig.externalMenuName.es  }} />
          </Button>
        </div>
      </PickerContent>
    </BaseDialog>
  )
}